import React from "react";
import { Chat, Phone, Email, Code, PhoneAndroid, Language, Build, Search, Storage } from "@material-ui/icons";
import { Button } from "@material-ui/core";
import Configs from "../../Assets/editable-stuff/configurations.json";

const WebAppServicesGrid = () => {
  const webServices = [
    {
      id: "webdesign",
      icon: <Language />,
      title: "Web Design",
      description: "Professional, attractive, and user-friendly website designs that deliver compelling experiences while integrating with your brand identity.",
      color: "#6366f1"
    },
    {
      id: "webdev",
      icon: <Code />,
      title: "Web Development",
      description: "Elegant, scalable web applications built with modern technologies that put power in the hands of your enterprise.",
      color: "#8b5cf6"
    },
    {
      id: "seo",
      icon: <Search />,
      title: "SEO Optimization",
      description: "Search engine optimization to boost your online visibility, grow sales, and attract more clients to your business.",
      color: "#06b6d4"
    },
    {
      id: "hosting",
      icon: <Storage />,
      title: "Web Hosting",
      description: "Every website needs reliable hosting. We'll find the right hosting plan that fits your needs and budget.",
      color: "#10b981"
    },
    {
      id: "maintenance",
      icon: <Build />,
      title: "Website Maintenance",
      description: "Keep your site updated, working properly, and optimized. Monthly maintenance services for ongoing support.",
      color: "#f59e0b"
    },
    {
      id: "appdev",
      icon: <PhoneAndroid />,
      title: "App Development",
      description: "Native and cross-platform mobile applications for iOS and Android that deliver exceptional user experiences.",
      color: "#ef4444"
    }
  ];

  return (
    <section id="webAppServices" className="services-section webapp-services">
      <div className="services-container">
        <div className="section-header">
          <span className="section-label">Our Services</span>
          <h2 className="section-title">Digital Solutions for Your Business</h2>
          <p className="section-subtitle">
            From concept to launch, we build digital products that make an impact
          </p>
        </div>

        <div className="services-grid-modern services-grid-3col">
          {webServices.map((service, index) => (
            <div
              key={service.id}
              className="service-card-modern"
              style={{ '--accent-color': service.color }}
            >
              <div className="service-card-header">
                <div className="service-icon-wrapper service-icon-mui">
                  {service.icon}
                </div>
                <span className="service-number">0{index + 1}</span>
              </div>

              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>

              <div className="service-actions">
                <Button
                  className="service-btn"
                  variant="outlined"
                  size="small"
                  startIcon={<Phone />}
                  href={"tel: " + Configs.PhoneNumber}
                >
                  Call
                </Button>
                <Button
                  className="service-btn"
                  variant="outlined"
                  size="small"
                  startIcon={<Chat />}
                  href={"sms: " + Configs.PhoneNumber + "&body=" + Configs.websiteTemplate}
                >
                  Text
                </Button>
                <Button
                  className="service-btn"
                  variant="outlined"
                  size="small"
                  startIcon={<Email />}
                  href={"mailto: " + Configs.EmailAddress + "?subject=" + Configs.websiteSubject + "&body=" + Configs.websiteTemplate}
                >
                  Email
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="cta-banner cta-banner-webapp">
          <div className="cta-content">
            <h3>Ready to build something amazing?</h3>
            <p>Let's discuss your project and create a digital solution tailored to your needs.</p>
          </div>
          <div className="cta-actions">
            <Button
              className="cta-btn-primary"
              variant="contained"
              startIcon={<Phone />}
              href={"tel: " + Configs.PhoneNumber}
            >
              Get Started
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WebAppServicesGrid;
